<template>
    <div class="select-product-label-component">
        <a-select :disabled="disabled"
                  :placeholder="placeholder"
                  :value="value"
                  :mode="mode"
                  style="width: 100%"
                  @change="onChange">
            <a-select-option v-for="(productLabel, key) in productLabels" :key="key" :value="productLabel.id">
                <show-product-label style="margin: 3.5px;" role="img" :product-label="productLabel"/>
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import productLabelApi from '~/api/product_label'

export default {
  name: 'SelectProductLabelComponent',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'Selecteer...',
    },
    productCategory: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      productLabels: [],
      setValue: this.value,
    }
  },
  mounted () {
    this.initProductLabels()
  },
  computed: {
    mode () {
      return this.multiple ? 'multiple' : 'default'
    }
  },
  methods: {
    initProductLabels () {
      productLabelApi.getByProductCategory(this.productCategory).then(response => {
        this.productLabels = response.data
      })
    },
    onChange (productLabelIds) {
      this.setValue = productLabelIds
      this.$emit('change', productLabelIds)
      this.$emit('input', productLabelIds)
    }
  }
}
</script>